import draggable from './module/draggable'
import clickoutside from './module/clickoutside'
import selectBlur from "./module/selectblur";

const directives = {
  draggable,
  clickoutside,
  selectBlur,
}

export default directives



// WEBPACK FOOTER //
// ./src/directive/directives.js